<template>
  <div class="Notification" :class="{ 'Notification--Active': ready }">
    <div v-if="freeShippingTitle" class="FreeShippingNotification">
      <span class="js-pdp-notification-icon">
        <Icon icon="free-shipping" />
      </span>
      <span class="t5 FreeShippingNotification--Tooltip"
        >{{ freeShippingTitle }}
        <FreeShippingTooltip :text="freeShippingCopy" placement="top"
      /></span>
    </div>
    <span ref="message" class="js-pdp-notification-msg t5"></span>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import Icon from '../Global/Icon.vue';
import FreeShippingTooltip from '../Global/FreeShippingTooltip.vue';

const props = defineProps({
  freeShippingTitle: { type: String, default: '' },
  freeShippingCopy: { type: String, default: '' },
});

const freeShippingTitle = computed(() => props.freeShippingTitle);

const ready = ref(false);
const message = ref(null);

const observeHandler = () => {
  const element = message?.value ?? false;
  if (!element) return;

  const hasText = element.textContent.length > 0;
  setTimeout(() => (ready.value = hasText), 250);
};

document.addEventListener('dy:pdp:notification:set', observeHandler);
</script>
